// @ts-nocheck

import Client from '../client';
import { getLang } from '../i18n/l10n';
import { AuthServices } from '../types/auth';
import { UserAccountService } from '../types/user-account';
import InAppBrowser from '../utils/plugins/InAppBrowser';

import config from './app.config';

export const RedirectServices = Object.freeze({
  ACTIVATION: 'activation',
  AFFILIATION: 'affiliation',
  WITHDRAWAL: 'withdrawal',
  DEPOSIT: 'deposit',
  VIP_STATUS: 'vip-status',
  BONUS: 'bonus',
  FREEBETS: 'freebets',
  BETTING_SETTINGS: 'betting-settings',
  COMMUNICATION: 'communication',
  HOME: 'home',
  CGUPAGE: 'cgupage',
  RESPONSIBLE_GAMING: 'responsible_gaming',
  FAQ: 'faq',
  CONTACT: 'contact',
  ABOUT: 'about',
  REGISTER: 'register',
  SET_MY_GAMING_LIMITS: 'set_my_gaming_limits',
  SET_PROMOTION_LIMITS: 'set_promotion_limits',
  SELF_EXCLUSION: 'self_exclusion',
  PLAY_POKER: 'play_poker',
  PROMO: 'promo',
  SHOP: 'shop',
  MAIN_SHOP: 'main-shop',
  FANTASY: 'fantasy',
  TICKETS: 'tickets',
  OFFERS: 'offers',
  VOCAL_ASSISTANT: 'vocal-assistant',
  KL_ALL_RULES: 'kohlanta-all-rules',
  KL_LEADERBOARD: 'kohlanta-leaderboard',
  KL_ENROLLMENT_VIDEO_TUTORIAL: 'kohlanta-enrollment-video-tutorial',
  KL_T_RED_VIDEO_TUTORIAL: 'kohlanta-t-red-video-tutorial',
  KL_T_WHITE_VIDEO_TUTORIAL: 'kohlanta-t-white-video-tutorial',
  KL_ORIENTATION_VIDEO_TUTORIAL: 'kohlanta-orientation-video-tutorial',
  KL_POLE_VIDEO_TUTORIAL: 'kohlanta-pole-video-tutorial',
  ES_RM_J30_RESTRICTIONS: 'es_rm_j30_restrictions',
  DEEPLINK: 'deeplink',
  STATS: 'stats',
  NEWS: 'news',
  ENCODED_URL: 'encoded_url',
  GR_ALL_RULES: 'giftrace-all-rules',
  LOST_PASSWORD: 'lostpassword',
  MP: 'betting-monopoly',
  PROMOTIONS_SETTINGS: 'betting-promotions-settings',
  BOOM_RULES: 'betting-boom-rules',
  GRIDS_RULES: 'grids-rules',
});

export const PokerRedirectServices = Object.freeze({
  APP_STORE: 'app_store',
});

type Params = { [string]: string };

export const getRedirectUrl = (service: string, params?: Params) => {
  let redirectUrl = `${config.webHost[getLang()]}/redirect/index.php?service=${service}`;

  redirectUrl += `&betting_version=${Client.bettingVersion}`;
  redirectUrl += `&application=${Client.application}`;
  redirectUrl += `&platform=${Client.platform}`;
  redirectUrl += `&lang=${getLang()}`;

  // On est pas forcément dans le poker, donc certains params ne sont pas définis
  if (Client.appVersion) {
    redirectUrl += `&ver=${Client.appVersion}`;
  }
  if (Client.store) {
    redirectUrl += `&store=${Client.store}`;
  }
  if (Client.storeId) {
    redirectUrl += `&store_id=${Client.storeId}`;
  }

  if (Client.tracker) {
    redirectUrl += `&oid=${Client.tracker}`;
  }

  if (Client.embed) {
    if (!InAppBrowser.isAvailable()) {
      redirectUrl += `&betting_embedded=1`;
    } else {
      redirectUrl += `&embed=true`;
    }
  }

  if (params) {
    Object.keys(params).forEach((p) => {
      let param = p;
      let value = params[p];

      // Si on est sur le service ENCODED_URL, on va encoder l'url
      if (service === RedirectServices.ENCODED_URL) {
        if (p === 'url') {
          param = 'target';
          value = encodeURIComponent(value);
        }
      }
      redirectUrl += `&${param}=${value}`;
    });
  }

  return redirectUrl;
};

export const getPrivateIconUrl = (iconId: string) => {
  const isURI = iconId.indexOf('https://') === 0;
  // On va toujours chercher les icons sur les statics de prod
  return isURI ? iconId : `https://s.winamax.fr/i/icons/${iconId}.png`;
};

export const getWapiDynamicEndpoint = (): string => {
  return config.wapiEndpoint[getLang()];
};

export const getAuthFormUrl = (): string => {
  const endpoint = getWapiDynamicEndpoint();
  return `${endpoint}/${AuthServices.LOGIN}`;
};

export const getUserAccountFormUrl = (): string => {
  const endpoint = getWapiDynamicEndpoint();
  // endpoint = 'http://localhost:8080'; // local mode

  return `${endpoint}/${UserAccountService}`;
};

export const getPrivateImageUrl = (iconId: string) => {
  const isURI = iconId.indexOf('https://') === 0;
  // On va toujours chercher les icons sur les statics de prod
  return isURI ? iconId : `https://s.winamax.fr/i/${iconId}.png`;
};
